<template>
    <div id="aboutAndJoinUs">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">羽拾</div>
                    <div class="contentVal">
                        <span>探索和耕耘企业级⼤数据服务领域</span>
                        <span>构建以数据为基础的⽣态，不断为合作伙伴创造价值</span>
                    </div>
                </div>
            </div>
            <!--定位按钮区域-->
            <div class="btnWrap">
                <span @click="btnEvent(1)" :class="btnIndex === 1 ? 'active' : '' ">关于我们</span>
                <span @click="btnEvent(2)" :class="btnIndex === 2 ? 'active' : '' ">加入我们</span>
            </div>
        </div>
        <!--内容区-->
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "aboutAndJoinUs",
        data() {
            return {
                btnIndex: 1
            }
        },
        created() {
            this.btnEvent(1);
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            btnEvent(index) {
                this.btnIndex = index;
                switch (index) {
                    case 1:
                        this.$router.push({path: "/aboutUs"});
                        break;
                    case 2:
                        this.$router.push({path: "/joinUs"});
                        break;
                }
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #aboutAndJoinUs {
        .bannerWrap {
            background: url("../../assets/img/aboutAndJoinUs/bg.png") no-repeat center;
            background-color: #00051D;

            .content {
                margin-top: 12px;
            }
        }
    }
</style>